import { customAxios } from './customAxios'
import { getNextDateMidnight } from 'utils/general-utilities'

export function getListaPratiche() {
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const fetchListaPratiche = customAxios
    .get(
      process.env.REACT_APP_BACKEND_HOST +
        '/' +
        process.env.REACT_APP_PATH_NEW_PREFIX +
        '/getListaPratichePaged',
      config,
    )
    .then(res => res.data.body)
  return fetchListaPratiche
}

export async function getListaPraticheV2(filters) {
  const { elementi, pagina, sortBy, sortDirection } = filters.queryParams
  const { body } = filters
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const params = new URLSearchParams()
  if (elementi !== null) {
    params.append('elementi', elementi)
  }
  if (pagina !== null) {
    params.append('pagina', pagina)
  }

  if (sortBy !== null) {
    params.append('sortBy', sortBy)
  }

  if (sortDirection !== null) {
    params.append('sortDirection', sortDirection.toUpperCase())
  }

  let newBody = { ...body }
  const { dataAperturaAl, dataChiusuraAl } = newBody
  if (dataAperturaAl) {
    newBody = {
      ...newBody,
      dataAperturaAl: getNextDateMidnight(new Date(dataAperturaAl)),
    }
  }
  if (dataChiusuraAl) {
    newBody = {
      ...newBody,
      dataChiusuraAl: getNextDateMidnight(new Date(dataChiusuraAl)),
    }
  }

  const res = await customAxios.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${
      process.env.REACT_APP_PATH_NEW_PREFIX
    }/getListaPratichePaged?${params.toString()}`,
    newBody,
    config,
  )
  if (res.status === 200) {
    return res.data.body
  }

  throw new Error('Error in calling getListaPratiche')
}

export async function getListaPraticheV3(filters) {
  const { elementi, pagina, sortBy, sortDirection } = filters.queryParams
  const { body } = filters
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const params = new URLSearchParams()


  if (sortBy !== null) {
    params.append('sortBy', sortBy)
  }

  if (sortDirection !== null) {
    params.append('sortDirection', sortDirection.toUpperCase())
  }

  let newBody = { ...body }
  const { dataAperturaAl, dataChiusuraAl } = newBody
  if (dataAperturaAl) {
    newBody = {
      ...newBody,
      dataAperturaAl: getNextDateMidnight(new Date(dataAperturaAl)),
    }
  }
  if (dataChiusuraAl) {
    newBody = {
      ...newBody,
      dataChiusuraAl: getNextDateMidnight(new Date(dataChiusuraAl)),
    }
  }

  const res = await customAxios.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${
      process.env.REACT_APP_PATH_NEW_PREFIX
    }/getListaPratiche?${params.toString()}`,
    newBody,
    config,
  )
  if (res.status === 200) {
    return res.data.body
  }

  throw new Error('Error in calling getListaPratiche')
}


export async function getListaPraticheByCFAndRS(codiceFiscale, ragioneSociale) {
  const params = new URLSearchParams()

  params.append('codiceFiscale', codiceFiscale ? codiceFiscale : '')

  params.append('ragioneSociale', ragioneSociale ? ragioneSociale : '')

  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_BACKEND_HOST}/${
      process.env.REACT_APP_PATH_NEW_PREFIX
    }/getListaPraticheByCFAndRS?${params.toString()}`,
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const res = await customAxios.request(config)
  if (res.status === 200) {
    return res.data.body
  }

  throw new Error('Error in calling getListaPratiche')
}
